// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const InfoItem: MarkdocTagRegistration = {
  tag: 'info-item',
  component: 'InfoItem',
  attributes: {
    header: {
      type: String,
      required: true,
      description: 'This is the header of the info item.',
      localizable: true,
    },
    icon: {
      type: String,
      required: false,
      description:
        'Pass in an Sail icon to override the default icon that is shown in the header. (View go/sail/Icon).',
    },
    content: {
      type: String,
      required: true,
      description: 'This is the content of the info item.',
      localizable: true,
    },
  },
};
